import { JsonDiscriminatorValue, JsonObject } from "ta-json";

import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";

/**
 * DateTimeOffset property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.DateTimeOffset)
export class DateTimeOffsetPropertyDefinition extends PropertyDefinition {
    constructor(name: string, init?: Omit<Partial<DateTimeOffsetPropertyDefinition>, "name">) {
        super(name, DataType.DateTimeOffset);
        Object.assign(this, init);
    }
}
